<template>
  <div>
    <header-page :style="isCiudadano? 'display: none': ''" showCiudadSelector :disabled="true" />
    <div class="container">
      <breadcrumbs :visible="!isCiudadano"/>
      <div class="row">
        <q-icon class="iconBack col-1" v-if="isCiudadano" name="arrow_back_ios" @click="goBack()" />
        <div v-if="isCiudadano && this.ciudadSelected!=null" class="tituloCiudad col-10">
          {{this.ciudadSelected.name}}
        </div>
      </div>
      <div class="row">
        <div :class="{ 'col-md-12': loopRuning === null, 'col-md-11': loopRuning != null }">
          <q-btn
            v-if="!isCiudadano"
            id="btnPrintPdf"
            @click="printPdf()"
            class="bPrincipal">Imprimir</q-btn>
        </div>
        <div class ='col-sm-1 dBtnLoop' v-if="!isCiudadano && loopRuning != null">
            <q-btn
              flat
              color="primary"
              icon="play_arrow"
              v-if="!this.loopRuning"
              @click="iniciarLoop"
            >
              <q-tooltip>Iniciar Loop</q-tooltip>
            </q-btn>
            <q-btn
              flat
              v-else
              color="primary"
              icon="pause"
              @click="pausarLoop"
            >
              <q-tooltip>Pausar loop</q-tooltip>
            </q-btn>
          </div>
      </div>

      <!--headerIndicador-->
      <HeaderIndicador :dataIndicador="dataIndicador"/>

      <!--filtro periodo-->
      <PeriodoIndicador :dataIndicador="dataIndicadorPeriod"/>

      <!--gráficos-->
      <GraficosIndicador v-if="Object.keys(this.dataIndicador).length !== 0" :dataIndicador="dataIndicador"/>

      <!--Acciones-->
      <ListadoAcciones v-if="dataIndicador.hasOwnProperty('acciones')" :acciones="dataIndicador.acciones" :styleCard="'margin: 20px 0px 0px 0px;'" :visibleColumns="this.isCiudadano ? ['name', 'fase', 'fechaInicio', 'fechaFin'] : ['name', 'fase', 'fechaInicio', 'fechaFin', 'ver']" />

      <!--descripción del indicador-->
      <DescriptionIndicador :dataIndicador="dataIndicador"/>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import DescriptionIndicador from '../components/DescriptionIndicador.vue';
import HeaderIndicador from '../components/HeaderIndicador.vue';
import PeriodoIndicador from '../components/PeriodoIndicador.vue';
import GraficosIndicador from '../components/GraficosIndicador.vue';
import { mapGetters } from 'vuex';
import HeaderPage from '@/components/shared/HeaderPage.vue';
import ListadoAcciones from '@/components/Aue/components/ListadoAcciones.vue';
import * as detailLoopHelper from '@/components/shared/helpers/detailLoopHelper.js';

export default {
  components: {
    Breadcrumbs,
    DescriptionIndicador,
    HeaderIndicador,
    PeriodoIndicador,
    GraficosIndicador,
    HeaderPage,
    ListadoAcciones
  },
  mixins: [Loading],
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isCiudadano: 'NGUD/isCiudadano',
      loopIndicatorsInfo: types.LOOP_INDICATORS
    })
  },
  data () {
    return {
      idIndicador: null,
      dataIndicador: {},
      dataIndicadorPeriod: {},
      loopRuning: null
    };
  },
  watch: {
    ciudadSelected () {
      this.getData();
    },
    '$route.params.id': {
      handler: function () {
        this.getData(true);
        if (this.loopIndicatorsInfo.indicadores) {
          this.loopRuning = true;
          const boundHelper = detailLoopHelper.initLoop.bind(this);
          this.timeOutId = boundHelper(this.$route.params.idIndicador, this.loopIndicatorsInfo.indicadores, this.loopIndicatorsInfo.loopTime);
        }
      },
      deep: true,
      immediate: true
    }
  },
  destroyed () {
    if (this.timeOutId) {
      clearTimeout(this.timeOutId);
    }
  },
  methods: {
    goBack () {
      this.$router.back();
    },
    iniciarLoop () {
      if (this.loopIndicatorsInfo.indicadores) {
        this.loopRuning = true;
        const boundHelper = detailLoopHelper.initLoop.bind(this);
        this.timeOutId = boundHelper(this.$route.params.idIndicador, this.loopIndicatorsInfo.indicadores, this.loopIndicatorsInfo.loopTime);
      }
    },
    pausarLoop () {
      if (this.timeOutId) {
        clearTimeout(this.timeOutId);
        this.loopRuning = false;
      }
    },
    async getData (paramsChange = false) {
      this.dataIndicador = {};
      this.showLoading();
      if (this.ciudadSelected !== null) {
        await this.$store.dispatch(types.ACTION_GET_INDICADOR_CIUDAD, {
          idCiudad: this.ciudadSelected.id,
          idIndicador: this.$route.params.idIndicador,
          idRelacionAUE: this.$route.params.idRelacionAUE
        }).then(response => {
          this.dataIndicador = response.data;
          this.dataIndicadorPeriod = response.data;
          this.hideLoading();
        }).catch(() => {
          this.hideLoading();
        });
      }
    },
    printPdf () {
      window.print();
    }
  }
};
</script>

<style lang="scss" scoped>
.bPrincipal{
  float: right;
  margin-bottom: 15px;
}
::v-deep{
  .layout-container.show-layout.unset-all {
    all: inherit !important;
  }
}
.dBtnLoop{
    align-self: start;
    display: flex;
    justify-content: end;
}
.iconBack {
  color:#666;
  font-size: 15px;
  cursor: pointer;
  padding-top: 15px;
  padding-bottom: 15px;
  justify-content: flex-start;
  display: flex;
}
.tituloCiudad {
  font-family: DINPro;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #002f6c;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 640px) {
  ::v-deep {
    .container {
      padding-left: 10px;
      padding-right: 10px;
    }
    .divNameIndic, .titleCard, .titleDetalle{
      font-size: 15px !important;
    }
    .titleDescription{
      font-size: 13px !important;
    }
    .contentDescription{
      font-size: 12px !important;
    }
    .measuring-container {
      margin-top: 15px;
    }
    .measuring, #measuring-big, #measuring-unit-big, .titleDesglose {
      font-size: 14px !important;
    }
    #measuring-date-big, #measuring-date {
      font-size: 10px !important;
    }
    //grafico responsive
    .chart {
      height: 230px !important;
    }
    .grafico.col-12 {
      margin: 0px;
    }
    // mapa responsive
    .divMap {
      height: 270px !important;
    }
    .leaflet-top.leaflet-right {
      margin-right: 0px !important;
    }
    .leaflet-control-layers-toggle{
      width: 30px !important;
      height: 30px !important;
      background-size: 30px !important;
    }
    .leaflet-control-zoom-in, .leaflet-control-zoom-out{
      width: 20px !important;
      height: 19px !important;
      line-height: 19px !important;
      font-size: 12px;
    }
    #no-scrolling-clicking.container-navigation-timeline.col-12.center{
      height: 35px !important;
      margin: 0px
    }
    .close-container {
      display: grid !important;
    }
    .controlers > button, .close-container > button {
      font-size: 8px !important;
    }
    .timeline{
      height: 20px !important;
    }
    .timeline-list {
      font-size: 6px !important;
    }
    .q-slider__thumb {
      height: 12px !important;
      width: 12px !important;
    }
    .q-slider__text-container {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
    .q-slider__text {
      font-size: 10px;
    }
    .itemLegend{
      font-size: 8px !important;
    }
    .divHeader, .divBody, .divLabel{
        font-size: 13px !important;
    }
    .q-table {
        th{
          font-size: 13px !important;
        }
        tbody td{
          font-size: 13px !important;
        }
    }
    .iconDetalle{
      font-size: 24px;
    }
    .q-table {
          th{
            font-size: 13px !important;
          }
          tbody td{
            font-size: 13px !important;
          }
      }
      .q-icon{
        font-size: 24px;
      }
      .titleDetalle {
        font-size: 15px !important;
      }
  }
}
@media print {
  #btnPrintPdf{
      display: none;
  }
}
</style>
